import { mobileBreakpoint } from "../../lib/helper/viewportHelper"
import { makeStyles } from "@material-ui/core/styles"

export default makeStyles(theme => ({
    resultGrid: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "flex-start",
        [theme.breakpoints.down(mobileBreakpoint)]: {
            alignItems: "center",
            flexDirection: "column"
        }
    },
    marginTop40: {
        marginTop: 40
    },
    dealerSearchFilterWrapper: {
        padding: "20px",
        marginTop: 20
    },
    padding5: {
        padding: 5
    },
    resultCard: {
        width: "250px",
        minHeight: "200px"
    }
}))
